/*
 *  Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { BudgetTab } from "~/components/Budgets";
import { useApplicationBudget } from "./hooks";

type Props = {
  appId: string;
};

export function ApplicationBudgetSection({ appId }: Props) {
  const {
    createApplicationBudget,
    updateApplicationBudget,
    budget,
    spends,
    forecast,
    loading,
    error,
    year,
    setYear,
    getGeneratedBudget,
    isBudgetGenerated,
    sumOfEnvBudgets,
    reset,
  } = useApplicationBudget(appId);

  return (
    <BudgetTab
      budget={budget}
      childrenBudget={sumOfEnvBudgets}
      spends={spends}
      forecast={forecast}
      year={year}
      loading={loading}
      error={error}
      isBudgetGenerated={isBudgetGenerated}
      warningCaption="The total environmental budgets are greater than the application budget."
      onSetYear={setYear}
      onCreateBudget={createApplicationBudget}
      onEditBudget={updateApplicationBudget}
      onGetGeneratedBudget={() => getGeneratedBudget()}
      onBudgetReset={reset}
    />
  );
}
